import { useCustomSyncProposalStageMeasurementsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCustomSyncProposalStageMeasurements() {
  const [mutation, { loading, error, data }] = useCustomSyncProposalStageMeasurementsMutation({
    refetchQueries: ["customGetProposal"],
  });

  const [customMutation, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "syncProposalStageMeasurements",
    },
    {
      hideMessage: true,
    }
  );

  return [customMutation, context] as const;
}
